export default "__VITE_ASSET__CK3Y2VvU__"